<template>
    <div class="seatingView innerMainContent" id="dCo"  @click="closeOpenTable($event)">
        <div class="innerHeader">
            <div class="col-xs-12">
                <div class="col-md-4 col-xs-12">
                    <div class="h1Wrap">
                        <svg class="i_calender"><use xlink:href="#i_calender"></use></svg>
                        <div class="innerH1Wrap">
                            <h1>{{ $t('seating') }}</h1>
                            <ul class="breadcrumb">
                                <li><router-link to="/">{{ $t('menu_hp') }}</router-link></li>
                                <li v-if="this.$store.state.user.type == 2"><router-link v-bind:to="'/event/wedding/'+event.id">{{ $t('event') }}</router-link></li>
                                <li class="active">{{ $t('seating') }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-xs-12" v-if="!$store.state.isTablet">
                    <div class="col-xs-12">
                        <div class="col-md-4 matchHeight">
                            <div class="totalSeats">
                                <div class="innerTotalSeats">
                                    <div>
                                        <span class="ulamCapacity">{{ getSeats('all') }}</span><span>{{ $t('total') }}</span>
                                    </div>
                                    <div>{{ $t('hallPlaces') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 matchHeight" v-if="!$store.state.isTablet">
                            <div class="innerBox precentageWrap seatedPlaces">
                                <div class="circlePrecWrap ">
                                    <svg viewBox="0 0 36 36" class="circular-chart">
                                        <path class="circle-bg" d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <path class="circle" stroke-dasharray="0, 100"
                                              v-bind:stroke-dasharray="(isNaN(((isNaN(Math.round((getSeats('taken')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('taken')/getSeats('seats'))*100)))) ? 0 : ((isNaN(Math.round((getSeats('taken')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('taken')/getSeats('seats'))*100)))) + ', 100'"
                                              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <text x="18" y="20.35" class="percentage">{{
                                            (isNaN(Math.round((getSeats('taken')/getSeats('seats'))*100))
                                            ? 0 :
                                            Math.round((getSeats('taken')/getSeats('seats'))*100))
                                            }}%
                                        </text>
                                    </svg>
                                </div>
                                <div class="precentageTxt">
                                    <div class="precentageIcon"><span class="mainIcon"></span>
                                        <span></span></div>
                                    <div class="placesNum">{{ getSeats('taken') }}</div>
                                    <div class="seatedStatus">{{ $t('taken') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 matchHeight" v-if="!$store.state.isTablet">
                            <div class="innerBox precentageWrap unSeatedPlaces">
                                <div class="circlePrecWrap ">
                                    <svg viewBox="0 0 36 36" class="circular-chart">
                                        <path class="circle-bg" d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <path class="circle" stroke-dasharray="0, 100"
                                              v-bind:stroke-dasharray="(isNaN(((isNaN(Math.round((getSeats('available')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('available')/getSeats('seats'))*100)))) ? 0 : ((isNaN(Math.round((getSeats('available')/getSeats('seats'))*100)) ? 0 : Math.round((getSeats('available')/getSeats('seats'))*100)))) + ', 100'"
                                              d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"></path>
                                        <text x="18" y="20.35" class="percentage">{{
                                            (isNaN(Math.round((getSeats('available')/getSeats('seats'))*100))
                                            ? 0 :
                                            Math.round((getSeats('available')/getSeats('seats'))*100))
                                            }}%
                                        </text>
                                    </svg>
                                </div>
                                <div class="precentageTxt">
                                    <div class="precentageIcon"><span class="mainIcon"></span>
                                        <span></span></div>
                                    <div class="placesNum">{{ getSeats('available') }}</div>
                                    <div class="seatedStatus">{{ $t('available') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-xs-12" style="text-align:left;padding-top:35px" v-if="!$store.state.isTablet">
                    <div class="row">
                        <button class="howToStart" @click="tableSwap()" v-if="(!event.presetLocked || $store.state.user.type === 2)">
                            <span>{{ $t('tableSwap') }}</span>
                        </button>
                    </div>
                    <div v-if="false" class="row">
                        <button class="howToStart">
                            <svg class="i_questionMark"><use xlink:href="#i_questionMark"></use></svg>
                            <span>{{ $t('getStarted') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottomPart" v-if="!showLoader">
            <div class="row" v-if="$store.state.isTablet">
                <div class="clearfix">
                    <h3>
                        <span>{{ $t('currentArrivalStatus') }}</span>
                    </h3>
                    <div>
                        <ul>
                            <li><strong>{{ arrived }}</strong> {{ $t('arrived') }}</li>
                            <li><strong>{{ seated }}</strong> {{ $t('seated') }}</li>
                            <li><strong>{{ percentage }}%</strong> {{ $t('attendance') }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="innerBox guestFilter">
                        <div class="col-xs-3">
                            <div class="statusBar">
                                <button v-bind:title="$t('willCome')" type="button" @click.prevent="setStatusFilter('coming')" id="arrive" class="statusBtn" v-bind:class="statusFilter == 'coming' ? 'active' : ''" v-tippy>
                                    <svg class="draggableGuestIcon i_arriving"><use xlink:href="#i_arriving"></use></svg>
                                    <span style="display: block;line-height: 20px"><strong>{{guests.coming}}</strong></span>
                                </button>
                                <button v-bind:title="$t('notComing')" type="button" @click.prevent="setStatusFilter('notComing')" id="notArriving" class="statusBtn" v-bind:class="statusFilter == 'notComing' ? 'active' : ''" v-tippy>
                                    <svg class="draggableGuestIcon i_notArriving"><use xlink:href="#i_notArriving"></use></svg>
                                    <span style="display: block;line-height: 20px"><strong>{{guests.notComing}}</strong></span>
                                </button>
                                <button v-bind:title="$t('mayCome')" type="button" @click.prevent="setStatusFilter('maybeComing')" id="maybeArriving" class="statusBtn" v-bind:class="statusFilter == 'maybeComing' ? 'active' : ''" v-tippy>
                                    <svg class="draggableGuestIcon i_maybeArriving"><use xlink:href="#i_maybeArriving"></use></svg>
                                    <span style="display: block;line-height: 20px"><strong>{{guests.maybe}}</strong></span>
                                </button>
                                <button v-bind:title="$t('notResponded')" type="button" @click.prevent="setStatusFilter('notResponded')" id="didentAnswer" class="statusBtn" v-bind:class="statusFilter == 'notResponded' ? 'active' : ''" v-tippy>
                                    <svg class="draggableGuestIcon i_didentAnswer"><use xlink:href="#i_didentAnswer"></use></svg>
                                    <span style="display: block;line-height: 20px"><strong>{{guests.notResponded}}</strong></span>
                                </button>
                                <button v-bind:title="$t('reserve')" type="button" @click.prevent="setStatusFilter('reserve')" id="isReserve" class="statusBtn" v-bind:class="statusFilter == 'reserve' ? 'active' : ''" v-tippy>
                                    R
                                    <span style="display: block;line-height: 20px"><strong>{{guests.reserve}}</strong></span>
                                </button>
                                <button type="button" @click.prevent="setStatusFilter('all')" id="all" class="statusBtn" v-bind:class="statusFilter == 'all' ? 'active' : ''">
                                    <span>{{ $t('all') }}
                                        <span style="display: block;line-height: 20px"><strong>{{guests.coming+guests.notComing+guests.maybe+guests.notResponded}}</strong></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div class="col-xs-3">
                            <div class="inputWrap searchWrapper">
                                <input type="search" v-model="openSearch" v-bind:placeholder="$t('searchGuestBy') + '...'">
                                <button class="searchEvent">
                                    <svg><use xlink:href="#i_search"></use></svg>
                                    <span class="sr-only">{{ $t('searchGuestBy') }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="col-xs-3">
                            <div class="inputWrap">
                                <div class="selectWrap">
                                    <select name="seatingStatus" id="seatingStatus" v-model="seatedFilter">
                                        <option value="all">{{ `${$t('guestsStatus')}: ${$t('all')}` }}</option>
                                        <option value="seated">{{ $t('seated') }}</option>
                                        <option value="notSeated">{{ $t('notSeated') }}</option>
                                    </select>
                                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-3">
                            <div class="inputWrap">
                                <div class="selectWrap">
                                    <select name="chooseGroup" id="chooseGroup" v-model="groupFilter">
                                        <option value="all">{{ `${$t('chooseGroup')}: ${$t('all')}` }}</option>
                                        <option value="all">{{ $t('all') }}</option>
                                        <option v-for="group in event.guestGroups" v-bind:value="group">{{ group }}</option>
                                    </select>
                                    <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="!$store.state.isTablet" class="col-md-3" v-bind:class="!$store.state.isTablet ? 'sideHeight' : ''">
                    <div class="innerBox guestWrap" v-if="!$store.state.isTablet">

                        <h2>{{ $t('guests') }} <span class="placeNumbers">(<span class="ulamCapacity">{{ getTotalGuests(true) }}</span>)</span></h2>
                        <div class="scrollerWrap">
                            <ul v-bind:id="(!event.presetLocked || $store.state.user.type === 2) ? 'dragablleItems' : ''" class="guestList">
                                <DraggableGuest v-for="(guest,key) of getGuests(true)" :presetLocked="event.presetLocked" :key="key" :draggableGuest="guest"></DraggableGuest>
                            </ul>
                        </div>
                        <div class="text-left" style="text-align:left;direction: ltr;font-weight: bold;font-size:20pt;cursor: pointer;">
                            <i class="la la-angle-left" @click="(currentPage != getPages ? currentPage++ : false)" v-bind:class="currentPage == getPages ? 'not_active' : ''"></i>
                            <i v-if="currentPage>=1">{{ currentPage }}/{{ getPages }}</i>
                            <i class="la la-angle-right" v-bind:class="currentPage == 1 ? 'not_active' : ''" @click="(currentPage > 1 ? currentPage-- : false)" v-if="getPages > 1"></i>
                        </div>
                    </div>
                </div>
                <div v-bind:class="!$store.state.isTablet ? 'sideHeight col-md-8' : 'col-md-12'">
                    <div class="innerBox ulamLayoutWrapper">
                        <div id="ulamLayout" v-bind:style="'background-image:url(\''+event.preset.background+'\')'">

                            <div class="grid" id="gridWrap"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottomPart text-center" v-if="showLoader">
            <rotate-loader style="opacity: .6" :color="'#132C43'"></rotate-loader>
        </div>

        <div id="modal-editGuest" class="seatingView modal">
            <button data-iziModal-close class="icon-close">
                <svg><use xlink:href="#i_close"></use></svg>
                <span class="sr-only">{{ $t('close') }}</span>
            </button>
            <div>
                <h2>{{ $t('editGuest_2') }}</h2>
                <h3>
                    <svg><use xlink:href="#i_user"></use></svg>
                    <span id="guestName"></span>
                </h3>
                <form action="#" onsubmit="return window.saveGuest()">
                    <input type="hidden" id="eventID"/>
                    <input type="hidden" id="guestID"/>
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <div class="inputWrap">
                                <label for="guestNameEdit">{{ $t('guestName') }}</label>
                                <input type="text" id="guestNameEdit" name="guestNameEdit" required>
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12">
                            <div class="row secondLevel">

                                <div class="col-md-6 col-xs-12">
                                    <label>{{ $t('comingQuantity') }}</label>
                                    <div class="guestCounter">
                                        <span class="plus"><svg><use xlink:href="#i_plus"></use></svg></span>
                                        <span class="value" id="guestComingQuantity"></span>
                                        <span class="minus"><svg><use xlink:href="#i_minus"></use></svg></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-xs-12">
                            <div class="inputWrap">
                                <label for="reserve">{{ $t('reserve') }}
                                    <select name="reserve" id="reserve" value="no">
                                        <option value="no" selected>{{ $t('no') }}</option>
                                        <option value="yes">{{ $t('yes') }}</option>
                                    </select>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12" v-if="event.isConference">
                            <div class="inputWrap">
                                <label for="companyEdit">{{ $t('company') }} {{ $t('conferenceOnly') }}</label>
                                <input type="text" id="companyEdit" name="companyEdit">
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12" v-if="event.isConference">
                            <div class="inputWrap">
                                <label for="roleEdit">{{ $t('role') }} {{ $t('conferenceOnly') }}</label>
                                <input type="text" id="roleEdit" name="roleEdit">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <div class="inputWrap">
                               <label for="modalGuestGroup">{{ $t('groupName') }}</label>
                               <input type="text" id="modalGuestGroup" name="modalGuestGroup">
                            </div>

                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <div class="inputWrap submitWrap deleteBtn">
                                <button class="submit">
                                    <svg class="i_delete"><use xlink:href="#i_close"></use></svg>
                                    <span>{{ $t('deleteGuest') }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12">
                            <div class="inputWrap submitWrap">
                                <button class="submit">{{ $t('hereYouSave') }}</button>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
        <div class="tableGuestList open" v-show="tableGuestListOpen" v-bind:style="tableGuestListStyle">
            <div class="tableGuestListH">
                <div>
                    <button class="closeBtn" @click="tableGuestListOpen = false">
                        <svg><use xlink:href="#i_close"></use></svg>
                    </button>
                    <h3> {{ $t('tableNumber') }} <span id="tableNumber">{{ table.tableNum }}</span> </h3>
                </div>
                <div>

                    <label for="editbleTableName" id="tableName">{{ table.name ? table.name : $t('tableName') }}</label>

                    <button class="editName">
                        <svg><use xlink:href="#i_edit"></use></svg>
                    </button>
                    <div class="editWrap">
                        <input @change="savePresetChanges()" id="editbleTableName" name="editbleTableName" type="text" v-model="tableName" v-bind:placeholder="$t('tableName')">
                        <button class="saveNewName" @click.prevent="savePresetChanges()">
                            <svg><use xlink:href="#i_longArr"></use></svg>
                        </button>
                    </div>
                </div>
                <div>
                    <span class="tableCapacity">
                        <span>{{ $t('total') }}:</span>
                        <span id="tableCapacity">{{ table.tableCapcity }}</span>
                    </span>
                    <span class="tableAvailability">
                        <span>{{ $t('available') }}:</span>
                        <span id="availablePlaces">{{ table.tableCapcity-getSeatsStatusForTable(table.dbID).amount }}</span>
                    </span>
                    <span class="tableAvailability">
                        <span>{{ $t('seated2') }}:</span>
                        <span id="seated2">{{ getSeatsStatusForTable(table.dbID).amount }}</span>
                    </span>

                    <span class="tableAvailability">
                        <span>{{ $t('arrived') }}:</span>
                        <span id="arrived">{{ getSeatsStatusForTable(table.dbID).arrived }}</span>
                    </span>
                </div>
            </div>
            <div class="scrollerWrap">
                <ul id="addTable">
                    <li v-for='guest of table.guests' v-bind:data-guest-id="guest.id" class="guestItem">
                        <span data-status="yes" class="guestIcon">
                            <svg class="i_arraiving"><use xlink:href="#i_arraiving"></use></svg>
                        </span>
                        <span class="guestInfo">
                            <div class="guestName">{{ guest.fullName }}</div>
                            <div class="guestGroup">{{ guest.groupName }}</div>
                            <div class="guestTable">
                                <svg class="i_table"><use xlink:href="#i_filter"></use></svg>
                                <span class="guestAmount" v-if="guest.status.coming > 0"><svg class="i_user"><use xlink:href="#i_user" style="fill:#41b53e"></use></svg> <span style="color:#41b53e;font-weight:bold">{{ guest.status.coming }}</span></span>
                                <span class="guestAmount" v-if="guest.status.notComing > 0"><svg class="i_user" style="fill:#bb1b1b"><use xlink:href="#i_user"></use></svg> <span style="color:#bb1b1b;font-weight:bold">{{ guest.status.notComing }}</span></span>
                                <span class="guestAmount" v-if="guest.status.maybeComing > 0"><svg class="i_user" style="fill:#FAFF04"><use xlink:href="#i_user"></use></svg> <span style="color:#FAFF04;font-weight:bold">{{ guest.status.maybeComing }}</span></span>
                                <span class="guestAmount" v-if="guest.status.notResponded > 0"><svg class="i_user"><use xlink:href="#i_user"></use></svg> <span style="font-weight:bold">{{ guest.status.notResponded }}</span></span>
                                <span class="guestAmount" v-if="guest.status.reserve > 0"><svg class="i_user"><use xlink:href="#i_user"></use></svg> <span style="font-weight:bold">{{ guest.status.reserve }}</span></span>
                            </div></span>
                        <button class="guestEdit" @click="saveGuestChanges(guest.id,false)" v-if="!$store.state.isTablet && (!event.presetLocked || $store.state.user.type === 2)"><svg class="editGuestBtn"><use xlink:href="#i_filter"></use></svg>
                            <svg class="deleteGuestBtn"><use xlink:href="#i_close"></use></svg> <span class="sr-only">{{ $t('editGuest') }}</span></button></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import RotateLoader from 'vue-spinner/src/RotateLoader.vue'
    import Config from '../../Config'
    import DraggableGuest from './DraggableGuest'

    export default {
        name: "Seating",
        components:{
            RotateLoader,
            DraggableGuest
        },
        destroyed(){
            this._destroy()
        },
        beforeDestroy(){
            this._destroy()
        },
        data(){
            return{
                tableChangeThrottled:null,
                tableChangeThrottled2:null,
                statusFilter:'all',
                groupFilter:'all',
                tableGuestListOpen:false,
                tableGuestListPos:{top:0,left:0},
                currentPointerPosition:{x:0,y:0},
                dragulaInitiated:false,
                isDragging:false,
                seatedFilter:'all',
                openSearch:'',
                openedTableGuests:[],
                table:{name:'',guests:[],id:0},
                event:{type:{},hall:{},owner:{},preset:{},presetData:[],guests:[],guestGroups:{},tableNames:{}},
                guests:{
                    notResponded:0,
                    coming:0,
                    maybe:0,
                    notComing:0,
                    reserve:0,
                },
                tableName:'',
                showLoader:true,
                ipp:20,
                currentPage:1,
            }
        },

        watch:{
            table:function(){
               /* this.tableChangeThrottled = setTimeout(()=>{
                    if(typeof this.table === "object" && this.table.hasOwnProperty("name")) this.tableName = this.table.name;
                    clearTimeout(this.tableChangeThrottled);
                },100);*/
                if(typeof this.table === "object" && this.table.hasOwnProperty("name")) this.tableName = this.table.name;
            },
            event:function(){
                this.setTableGuests()
            }
        },

        computed: {

            tableGuestListStyle:function(){
                return {
                    display:'block',
                    left:this.tableGuestListPos.left,
                    top:this.tableGuestListPos.top
                }
            },

            getPages: function () {
                return Math.ceil(this.getGuests().length / this.ipp)
            },

            arrived() {

                let arrived = 0;
                if (this.event.hasOwnProperty('id') && this.event.hasOwnProperty('guests') && Array.isArray(this.event.guests)) {
                    this.event.guests.forEach(guest => {
                        if (guest.arrived) {
                            arrived +=
                                parseInt(guest.quantity) > 0 ? parseInt(guest.quantity) : 1;
                        }
                    });
                }

                return arrived;
            },

            seated() {

                let seated = 0;
                if (this.event.hasOwnProperty('id') && this.event.hasOwnProperty('guests') && Array.isArray(this.event.guests)) {
                    this.event.guests.forEach(guest => {
                        if (guest.tableID !== "" && guest.tableID) {
                            seated += guest.quantity;
                        }
                    });
                }

                return seated;
            },

            percentage() {
                let percentage = parseInt((this.arrived / this.seated) * 100);
                return isNaN(percentage) ? 0 : percentage;
            }
        },

        methods:{
            _destroy(){
                try{
                    $('body').off('click.bodyevents')
                    $('[id^="item_"] > div').off('mouseenter');
                    $('[id^="item_"] > div').off('mouseleave');
                    $('.tableWrap').off('click')
                    if(typeof $(".scrollerWrap").getNiceScroll === "function") $(".scrollerWrap").getNiceScroll().remove();
                    if(typeof $("#dragablleItems").getNiceScroll === 'function') $("#dragablleItems").getNiceScroll().remove();
                    $('.tableWrap').off('click')
                    this.dragulaInitiated = false;

                    if(window.hasOwnProperty('_dragula') && window._dragula.hasOwnProperty('destroy') && typeof window._dragula.destroy === 'function'){
                        window._dragula.destroy();
                    }

                }
                catch(e){
                }
            },
            destroyed(){
               this._destroy();
            },
            getSeatsStatusForTable(id = '',dontAddArrival = false, dontAddAmount = false){

                dontAddArrival = false; //DO NOT REMOVE - MANUAL OVERRIDE

                let status = {
                    confirmed:0,
                    notComing:0,
                    maybeComing:0,
                    reserve:0,
                    notResponded:0,
                    arrived:0,
                    notArrived:0,
                    amount:0
                };

                if(typeof id ==='undefined' || id == '' || !id) return status;
                if(this.event.guests.length > 0) {
                    for (let guest of this.event.guests) {
                        if(guest.tableID == id && typeof guest.status ==='object'){
                            if(!dontAddArrival && this.$store.state.isTablet) {
                                if (guest.arrived) {
                                    if(guest.status.coming ===0 && guest.status.maybeComing ===0 && guest.status.notComing === 0 && guest.status.reserve === 0 && guest.status.notResponded !== 0){
                                        guest.status = {
                                            coming:guest.status.notResponded,
                                            maybeComing:0,
                                            notComing:0,
                                            notResponded:0,
                                            reserve:0
                                        };
                                    }
                                    status.arrived += parseInt(guest.quantity) > 0 ? parseInt(guest.quantity) : 1;
                                } else {
                                    status.notArrived += guest.status.coming;
                                }
                            }

                            status.confirmed += guest.status.coming;
                            status.maybeComing += guest.status.maybeComing;
                            status.reserve += guest.status.reserve;
                            status.notComing += guest.status.notComing;
                            status.notResponded += guest.status.notResponded;
                            if(!dontAddAmount) status.amount += !isNaN(guest.quantity) ? parseInt(guest.quantity) : 0;

                        }
                    }
                }
                return status;

            },
            getSeatClass(status = ''){

                switch(status){
                    case 'arrived':
                    case 'confirmed':
                        return 'confirmed'
                        break;
                    case 'notComing':
                        return 'notComing'
                        break;
                    case 'maybeComing':
                        return 'maybe'
                        break;
                    case 'notArrived':
                    case 'notResponded':
                        return 'notResponded'
                        break;
                    case 'reserve':
                        return 'reserve'
                        break;
                    default:
                        return '';
                        break;
                }
            },
            getSeatsHtml(seatsStatus = {}, capacity = 0){
                let seats = [];
                for(let status in seatsStatus) {
                    if(this.$store.state.isTablet && status !== 'arrived' && status !== 'reserve' && status !== 'notArrived') continue;
                    let status_places = seatsStatus[status]
                    if (status_places > 0) {
                        for(let s = 1;s<=status_places;s++){
                            let seat = "<span class='seat " + this.getSeatClass(status) + "'></span>";
                            seats.push( seat );
                        }
                    }
                }
                for(let s = seats.length;s<=capacity-1;s++){
                    let seat = "<span class='seat " + this.getSeatClass('') + "'></span>";
                    seats.push( seat );
                }
                return seats;
            },
            isTableExist(id){
                return this.event.presetData.some(table => table.dbID === id);
            },
            getTableName(tableID){
                let table = "";
                this.event.presetData.some(_table => {
                    if(_table.dbID === tableID){
                        table = (_table.hasOwnProperty('name') && typeof _table.name !== 'undefined' ? _table.name : '');
                        return true;
                    }
                });

                return table;
            },
            getGuests(usePaging = false){
                let _this = this;
                if(typeof this.event.guests.filter !=='function') return [];
                let guests =  this.event.guests.filter((guest)=>{
                    if(_this.statusFilter != 'all' && guest.status[_this.statusFilter] <= 0) return false;
                    if(_this.openSearch != '' && guest.tableNumber != _this.openSearch && !guest.fullName.toString().toLowerCase().includes(_this.openSearch.toString().toLowerCase())&& guest.phone.toString() !== _this.openSearch.toString().toLowerCase()) return false;
                    if(_this.groupFilter != 'all' && _this.groupFilter != guest._group) return false;

                    if(_this.seatedFilter !== 'all'){

                        if(_this.seatedFilter == "seated" && _this.isTableExist(guest.tableID)){
                            return true;
                        }else{
                            return (_this.seatedFilter == "notSeated" && (!guest.tableID || guest.tableID == '' || guest.tableID == 0));
                        }

                    }

                    return true;
                });

                if(usePaging) {
                    let start = ((this.ipp*this.currentPage)-this.ipp);
                    let end = (this.ipp*this.currentPage);
                    guests = guests.slice(start,end)
                }

                return guests;

            },
            setLayout(layout){
                let _this = this
                if(layout.elements.length > 0){
                    for(let item of layout.elements){
                        item.occupiedPlaces = 0;
                        if(this.event.guests.length > 0){
                            if(item.type == 'table') {
                                for (let guest of this.event.guests) {
                                    if (guest.tableID == item.dbID && typeof guest.status === 'object') {
                                        item.occupiedPlaces += guest.status.coming;
                                    }
                                }
                            }
                        }
                    }
                }

                $('#gridWrap').html('');
                let message = typeof layout === 'object' ? layout : JSON.parse(layout);
                $.each(message.elements, function (index, element) {
                    let item = "";
                    let elmBackup = {};
                    let isReserved = element.hasOwnProperty("reserved") && element.reserved === true;
                    elmBackup = Object.assign({},element);

                    if(isReserved) element.tableNum = `${_this.$t('reserved')}${element.tableNum}`;

                    const tableNumRotation = (element.rotation ? (element.rotation > 0 ? 0-element.rotation : Math.abs(element.rotation)) : 0);

                    let scale = 'transform:scale('+(element.scale ? element.scale : 1)+')';
                    scale = scale + ' rotate('+(element.rotation ? element.rotation : 0)+'deg);';

                    if (element.type == "table") {
                        let tablehead = 0,
                            tableClass = "",
                            shapeClass = "";
                        switch (element.shape) {
                            case "circle" :
                                tablehead = 0;
                                tableClass = "circleTable";
                                shapeClass = "circle";
                                break;
                            case "square" :
                                tablehead = 0;
                                tableClass = "squareTable";
                                shapeClass = "square";
                                break;
                            case "rectangle" :
                                tablehead = (Math.round((element.tableCapcity/4)/2));
                                tableClass = "rectangleTable";
                                shapeClass = "rectangle";
                                break;
                            case "ellipse" :
                                tablehead = 1;
                                tableClass = "rectangleTable ellipseTable";
                                shapeClass = "rectangle";
                                break;
                        }


                        let overCapacity = false;
                        let _seated = _this.getSeatsStatusForTable(element.dbID,true,true);
                        let tableUsage = '';
                        if(typeof _seated ==='object'){
                            if(_this.$store.state.isTablet) {
                                _seated =
                                    parseInt(_seated.arrived);
                            } else {
                                _seated =
                                    parseInt(_seated.confirmed) + parseInt(_seated.notComing)
                                    + parseInt(_seated.maybeComing) + parseInt(_seated.notResponded)
                                    + parseInt(_seated.reserve);
                            }
                            overCapacity = (!isNaN(_seated) && _seated > element.tableCapcity);

                            tableUsage = `${_seated}/${element.tableCapcity}`;

                        }
                        if(overCapacity) tableClass = `${tableClass} overCapacity`

                        if(element.shape =='drop'){
                            item = '<span data-side1="'+(element.side1 ? element.side1 : '')+'" data-side2="'+(element.side2 ? element.side2 : '')+'" data-side3="'+(element.side3 ? element.side3 : '')+'" data-side4="'+(element.side4 ? element.side4 : '')+'" data-rotation="'+(element.rotation ? element.rotation : 0)+'" data-scale="'+(element.scale ? element.scale : 1)+'" class="item" style="'+scale+';top:'+element.position.y+';left:'+element.position.x+';"><div data-table-usage="'+tableUsage+'" data-shape="'+element.shape+'" data-dbid="'+element.dbID+'" id="item_' + element.id + '" class="tableWrap '+tableClass+'" data-tablehead="'+tablehead+'" data-capacity="'+element.tableCapcity+'" data-occupiedplaces="'+element.occupiedPlaces+'" data-type="table"><div class="'+shapeClass+'"><img src="/static/images/drop.png"><span class="tableNum" '+ (tableNumRotation !== 0 ? 'style="transform:rotate('+tableNumRotation+'deg);display:block"' : '') +'>'+element.tableNum+'</span></span></div></div></span>';
                        }else{
                            item = '<span data-side1="'+(element.side1 ? element.side1 : '')+'" data-side2="'+(element.side2 ? element.side2 : '')+'" data-side3="'+(element.side3 ? element.side3 : '')+'" data-side4="'+(element.side4 ? element.side4 : '')+'" data-rotation="'+(element.rotation ? element.rotation : 0)+'" data-scale="'+(element.scale ? element.scale : 1)+'" class="item" style="'+scale+';top:'+element.position.y+';left:'+element.position.x+';"><div data-table-usage="'+tableUsage+'" data-shape="'+element.shape+'" data-dbid="'+element.dbID+'" id="item_' + element.id + '" class="tableWrap '+tableClass+'" data-tablehead="'+tablehead+'" data-capacity="'+element.tableCapcity+'" data-occupiedplaces="'+element.occupiedPlaces+'" data-type="table"><div class="'+shapeClass+'"><span class="tableNum" '+ (tableNumRotation !== 0 ? 'style="transform:rotate('+tableNumRotation+'deg);display:block"' : '') +'>'+element.tableNum+'</span></span></div></div></span>';
                        }


                    } else {
                        item ='<span data-rotation="'+(element.rotation ? element.rotation : 0)+'" data-scale="'+(element.scale ? element.scale : 1)+'" class="item" style="'+scale+';top:'+element.position.y+';left:'+element.position.x+';"><div data-shape="'+element.shape+'" data-dbid="'+element.dbID+'" data-type="'+element.type+'" class="imgWrap"><img src="/static/images/'+element.type+'.png"></div></span>';

                    }
                    $('#gridWrap').append(item);

                    if(isReserved) element.tableNum = elmBackup.tableNum || "";
                });

                function resizable(el, factor) {
                    let int = Number(factor) || 7.7;

                    function resize() {
                        el.style.width = ((el.value.length + 1) * int) + 'px'
                    }

                    let e = 'keyup,keypress,focus,blur,change'.split(',');
                    for (let i in e) el.addEventListener(e[i], resize, false);
                    resize();
                }

                resizable(document.getElementById('editbleTableName'), 7);

                $(".squareTable").each(function() {
                    let capacity  = $(this).data("capacity"),
                        capacityPerSide = capacity/4,
                        size = (Math.round(capacityPerSide)) * 14,
                        text = "";

                    let seats = _this.getSeatsHtml(_this.getSeatsStatusForTable($(this).data('dbid'),true,true), capacity);

                    let sides = {};
                    if(typeof $(this).data('side1') !== 'undefined') {
                        sides = {
                            side0: (typeof $(this).data('side1') !== 'undefined' && $(this).data('side1') != '' ? $(this).data('side1') : ''),
                            side1: (typeof $(this).data('side2') !== 'undefined' && $(this).data('side2') != '' ? $(this).data('side2') : ''),
                            side2: (typeof $(this).data('side3') !== 'undefined' && $(this).data('side3') != '' ? $(this).data('side3') : ''),
                            side3: (typeof $(this).data('side4') !== 'undefined' && $(this).data('side4') != '' ? $(this).data('side4') : ''),
                        };
                    }else {
                        sides = {
                            side0: (typeof $(this).parent().data('side1') !== 'undefined' && $(this).parent().data('side1') != '' ? $(this).parent().data('side1') : ''),
                            side1: (typeof $(this).parent().data('side2') !== 'undefined' && $(this).parent().data('side2') != '' ? $(this).parent().data('side2') : ''),
                            side2: (typeof $(this).parent().data('side3') !== 'undefined' && $(this).parent().data('side3') != '' ? $(this).parent().data('side3') : ''),
                            side3: (typeof $(this).parent().data('side4') !== 'undefined' && $(this).parent().data('side4') != '' ? $(this).parent().data('side4') : ''),
                        };
                    }

                    $(this).find(".square").css({"width":size,"height":size,"line-height":(size-2)+"px"});
                    for (let i = 0; i < 4; i++) {
                        text += "<div class='tableSide side"+i+"'>";
                        if(sides[`side${i}`] && sides[`side${i}`] !== ''){
                            capacityPerSide = sides[`side${i}`];
                        }
                        for (let j = 0; j < capacityPerSide; j++) {
                            let seat = seats.shift();
                            if(typeof seat !=='undefined') text += seat;
                        }

                        //if left any un splitable seats
                        if(i === 4 && seats.length > 0){
                            text += seats.join("");
                        }
                        text += "</div>";
                    }
                    $(this).find(".square").append(text);
                });

                $(".circleTable").each(function() {
                    let capacity  = $(this).data("capacity"),
                        size = capacity * 3,
                        text = "",
                        rot = 0,
                        angle = 360/capacity,
                        angleV = 85,
                        occupiedPlaces  = $(this).data("occupiedplaces");

                    let seats = _this.getSeatsHtml(_this.getSeatsStatusForTable($(this).data('dbid'),true,true), capacity);

                    $(this).find(".circle").css({"width":size,"height":size,"line-height":(size-2)+"px"});
                    for (let i = 0; i < capacity; i++) {
                        let translateV=capacity*2,
                            rotateV = rot * 1;

                        let seat = seats.shift();
                        if(typeof seat !=='undefined'){
                            seat = $(seat).attr('style',"transform: rotate("+rotateV+"deg) translate("+translateV+"px) rotate("+angleV+"deg)")[0].outerHTML;
                            text += seat;

                            rot= rot + angle;
                            angleV = angleV + 1;
                        }

                    }
                    $(this).find(".circle").append(text);

                });
                $(".rectangleTable").each(function() {

                    let capacity  = $(this).data("capacity"),
                        tablehead  = $(this).data("tablehead"),
                        capacityPerSideHeight = (capacity - (tablehead*2))/2,
                        capacityPerSideWidth = tablehead,
                        width = Math.round(capacityPerSideWidth) * 14,
                        height = Math.round(capacityPerSideHeight) * 14,
                        text = "";

                    let seats = _this.getSeatsHtml(_this.getSeatsStatusForTable($(this).data('dbid'),true,true), capacity);

                    let sides = {};
                    if(typeof $(this).data('side1') !== 'undefined') {
                        sides = {
                            side0: (typeof $(this).data('side1') !== 'undefined' && $(this).data('side1') != '' ? $(this).data('side1') : ''),
                            side1: (typeof $(this).data('side2') !== 'undefined' && $(this).data('side2') != '' ? $(this).data('side2') : ''),
                            side2: (typeof $(this).data('side3') !== 'undefined' && $(this).data('side3') != '' ? $(this).data('side3') : ''),
                            side3: (typeof $(this).data('side4') !== 'undefined' && $(this).data('side4') != '' ? $(this).data('side4') : ''),
                        };
                    }else {
                        sides = {
                            side0: (typeof $(this).parent().data('side1') !== 'undefined' && $(this).parent().data('side1') != '' ? $(this).parent().data('side1') : ''),
                            side1: (typeof $(this).parent().data('side2') !== 'undefined' && $(this).parent().data('side2') != '' ? $(this).parent().data('side2') : ''),
                            side2: (typeof $(this).parent().data('side3') !== 'undefined' && $(this).parent().data('side3') != '' ? $(this).parent().data('side3') : ''),
                            side3: (typeof $(this).parent().data('side4') !== 'undefined' && $(this).parent().data('side4') != '' ? $(this).parent().data('side4') : ''),
                        };
                    }

                    if(sides.hasOwnProperty('side1') && sides.side1 !=='') width = sides.side1 * 16

                    $(this).find(".rectangle").css({"width":width,"height":height,"line-height":(height-2)+"px"});
                    for (let i = 0; i < 4; i++) {
                        text += "<div class='tableSide side"+i+"'>";

                        if(i == 1 || i==3){
                            if(sides[`side${i}`] && sides[`side${i}`] !== ''){
                                capacityPerSideWidth = sides[`side${i}`];
                            }
                            for (let j = 0; j < capacityPerSideWidth; j++) {
                                let seat = seats.shift();
                                if(typeof seat !=='undefined') text += seat;
                            }
                        }else{
                            if(sides[`side${i}`] && sides[`side${i}`] !== ''){
                                capacityPerSideHeight = sides[`side${i}`];
                            }
                            for (let j = 0; j < capacityPerSideHeight; j++) {
                                let seat = seats.shift();
                                if(typeof seat !=='undefined') text += seat;
                            }
                        }

                        text += "</div>";
                    }
                    $(this).find(".rectangle").append(text);
                });
            },
            initJS(){
                let _this = this;
                if(!this.dragulaInitiated) {
                    $.getScript("/static/js/dragula.min.js", function () {
                        $.getScript("/static/js/pie.min.js", function () {
                            $.getScript("/static/js/dependencies.js", function () {
                                _this._initJsFunctionallity();
                            });
                        });
                    });
                } else {
                    _this._initJsFunctionallity();
                }
            },

            _initJsFunctionallity(){
                this._destroy();

                const layout = {
                    elements: this.$data.event.presetData
                };

                this.setLayout(layout);

                //initiate dragula, guests seating

                if(!this.dragulaInitiated && !this.$store.state.isTablet) {
                    window._dragula =
                        dragula([document.getElementById('dragablleItems'),
                                 document.getElementById('addTable')], {
                                    copy: (el, source) => {
                                        return source === document.getElementById('dragablleItems');
                                    },
                                    accepts: (el, target) => {
                                        return target !== document.getElementById('dragablleItems');
                                    },
                                    mirrorContainer: document.getElementById('dCo')
                                })
                            .on('drag', (e, t) => {
                                if (!this.isDragging) {
                                    this.isDragging = true;
                                    this.tableGuestListOpen = false
                                }
                            }).on('drop', (e, t) => {
                            if (this.isDragging) {
                                setTimeout(() => {
                                    this.isDragging = false;
                                    this.saveGuestChanges($(e).data('guest-id'), true)
                                }, 200);
                            }
                        });
                    this.dragulaInitiated = true;
                }

                const self = this;

                //set/unset table on hover
                $('[id^="item_"] > div').on('mouseenter mouseleave click',function(e){
                    const dbID = $(this).parent().data('dbid');
                    const table = self.event.presetData.find(tbl=>tbl.dbID === dbID);

                    switch(e.type){
                        case "mouseenter":

                            if(self.table.dbID === dbID){
                                document.querySelector(`[data-dbid="${dbID}"] > div`).classList.add('active')
                                return;
                            }

                            document.querySelectorAll('[data-dbid] > div').forEach(_=>_.classList.remove("active"));
                            $(this).parent()[0].children[0].classList.add("active");
                        case "click":
                            if(!self.saving && table !== null && typeof table === "object"){
                                self.setTable(table, e.type === "click")
                            }

                            setTimeout(()=>{
                                if(e.type === "click") {
                                    //set guests
                                    self.table.guests = self.event.guests.filter(guest => guest.tableID === dbID);

                                    const x = ($(this).parent()[0].getBoundingClientRect().left + (($(this)[0].getBoundingClientRect().width) / 2)) + 7;
                                    const y = e.pageY - $('.tableGuestList').height() - 20;

                                    self.tableGuestListPos = {top:y,left:x};

                                    self.tableGuestListOpen = true;

                                    self.$forceUpdate();


                                    //todo finish with the guests list change
                                    //stopped in here while clicking on table!!
                                }
                            },52);


                            break;
                        case "mouseleave":
                            document.querySelectorAll('[data-dbid] > div').forEach(_=>_.classList.remove("active"))
                            setTimeout(()=>{
                               //if(self.table.dbID === dbID && !self.tableGuestListOpen) self.table = {name:'',guests:[],id:0};
                            },200);
                            break;
                    }

                });

                $(".editName").on('click', function () {
                    $('#editbleTableName').focus();
                });

                $("body").on('click.bodyevents', '.selectedValue', function () {
                    $('.statusDropDown').toggleClass('open');
                });

                $("body").on('click.bodyevents', '.seatingView .guestCounter span.plus', function (e) {
                    let value = parseInt($('.seatingView .guestCounter span.value').html());
                    value++;
                    $('.seatingView .guestCounter span.value').html(value);
                });
                $("body").on('click.bodyevents', '.seatingView .guestCounter span.minus', function (e) {
                    let value = parseInt($('.seatingView .guestCounter span.value').html());
                    if (value > 0) {
                        value--;
                    }

                    $('.seatingView .guestCounter span.value').html(value);
                });

            },
            closeOpenTable(e){
                let fromTableOrPopup = false

                e.path.forEach(_=>{
                    if($(_).hasClass('item')) fromTableOrPopup = true;
                    if($(_).hasClass('tableGuestList')) fromTableOrPopup = true;
                })
                if(!fromTableOrPopup) this.tableGuestListOpen = false
            },
            setStatusFilter(_){
                this.statusFilter = _;
            },
            getGuestsPercent(sum){
                let _ = Math.round((sum/this.getTotalGuests())*100);
                return isNaN(_) ? 0 : _;
            },
            getTotalGuests(filtered = false){
                if(filtered){
                    let total = 0;
                    this.getGuests().forEach(guest=>{

                        if(this.statusFilter !== "all"){
                            total += parseInt(guest.status[this.statusFilter]);
                        } else {
                            total += parseInt(guest.quantity);
                        }
                    })
                    return total;
                }
                return (this.guests.coming+this.guests.maybe+this.guests.notComing+this.guests.notResponded+this.guests.reserve);
            },
            getSeats(fetch = 'all'){
                let seats = 0;
                let taken = 0;
                let available = 0;
                const _this = this;
                this.event.presetData.forEach((item)=>{
                    if(item.type == 'table'){
                        if(!item.hasOwnProperty("reserved") || item.reserved !== true || _this.event.resevedSeatingAllowed === true) {
                            if (!isNaN(item.tableCapcity)) seats += parseInt(item.tableCapcity);
                            if (this.event.guests.length > 0) {
                                for (let guest of this.event.guests) {
                                    if (guest.tableID == item.dbID) {
                                        taken += parseInt(guest.quantity);
                                    }
                                }
                            }
                        }
                    }
                })

                switch(fetch){
                    case 'all':
                    default:
                        return seats;
                        break;

                    case 'taken':
                        return taken;
                        break;

                    case 'available':
                        return ((seats-taken) > 0 ? (seats-taken) : 0);
                        break;
                }
            },
            fetchGuests(forceUpdate = false){
                this.$store.dispatch('getGuests',this.event.id)
                    .then(response =>{
                        //success
                        this.event.guests = response.data
                        for(let g in this.event.guests){
                            this.event.guests[g].key = parseInt(g);
                        }
                        if(forceUpdate) this.$forceUpdate();
                        this.showLoader = false;
                        this.calculateGuests();
                        this.initJS()

                    })
                    .catch(err => {
                        //err
                        console.warn(err)
                        this.$router.push('/');
                        this.showLoader = false;
                    })
            },
            calculateGuests(){
                if(this.event.guests.length > 0 ){
                    let _this = this;

                    this.guests = {
                        notResponded:0,
                        coming:0,
                        maybe:0,
                        notComing:0,
                        reserve:0,
                    };

                    this.event.guests.forEach((_)=>{
                        _this.guests.notResponded += !isNaN(parseInt(_.status.notResponded)) ? parseInt(_.status.notResponded) : 0;
                        _this.guests.coming += !isNaN(parseInt(_.status.coming)) ? parseInt(_.status.coming) : 0;
                        _this.guests.maybe += !isNaN(parseInt(_.status.maybeComing)) ? parseInt(_.status.maybeComing) : 0;
                        _this.guests.reserve += !isNaN(parseInt(_.status.reserve)) ? parseInt(_.status.reserve) : 0;
                        _this.guests.notComing += !isNaN(parseInt(_.status.notComing)) ? parseInt(_.status.notComing) : 0;
                    })
                }
            },
            savePresetChanges(){
                if(this.tableName !== '' && typeof this.table === "object" && this.table.name !== this.tableName) this.table.name = this.tableName;
                this.$store.dispatch('updateEvent',{'id':this.event.id,'presetData':this.event.presetData})
                    .then((_)=>{
                        this.event.presetData = _.presetData;
                        this._destroy();
                        this.initJS();
                    })
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },
            saveGuestChanges(guestID,add = false){
                if(this.saving) return;
                this.saving = true;
                const tableID = this.table.dbID;
                const table = this.event.presetData.find(tbl=>tbl.dbID===tableID);

                if(table === null || typeof table === "undefined") return true;

                let _this = this;

                this.event.guests.some(guest=>{
                    if(guest.id === guestID){
                        if(add && this.event.guestsSeatingLimit !== null && !isNaN(this.event.guestsSeatingLimit) && this.event.guestsSeatingLimit > 0 && ( (this.seated+guest.quantity) > this.event.guestsSeatingLimit )){
                            this.$swal({
                                           confirmButtonText:this.$t('okButton'),
                                           type:'warning',
                                           title:this.$t('guestsSeatingLimitNotification_title'),
                                           text: this.$t('guestsSeatingLimitNotification_text', {quantity: this.event.guestsSeatingLimit}),
                                           timer:3000
                                       }).catch(this.$swal.noop);
                            this.fetchGuests();
                            this.saving = false;
                            return;
                        }

                        if(add){
                            guest.tableID = tableID;
                        }else{
                            guest.tableID = 'unset';
                        }

                        guest.tableNumber = '';

                        const isReserved = table.hasOwnProperty("reserved") && table.reserved === true;
                        if(this.event.strictTables || (isReserved && this.event.resevedSeatingAllowed !== true)) {

                            if (add && ((isReserved)||(typeof table === "object" && (this.getSeatsStatusForTable(tableID, true, false).amount >= (table.tableCapcity + 1) || this.getSeatsStatusForTable(tableID, true, false).confirmed >= (table.tableCapcity + 1))))) {
                                this.$swal({
                                    confirmButtonText:this.$t('okButton'),
                                    type:'warning',
                                    title:this.$t(isReserved ? 'reservedTableWarning' : 'strictTablesWarning'),
                                    timer:3000
                                }).catch(this.$swal.noop);
                                this.fetchGuests();
                                this.saving = false;
                                return;
                            }
                        }

                        _this.table.guests = _this.event.guests.filter(guest=>{
                            return guest.tableID === tableID
                        });
                        this.$forceUpdate();

                        this.$store.dispatch('updateGuest',guest)
                                                .then(response =>{
                                                    //success
                                                    this.fetchGuests();
                                                })
                                                .catch(err => {
                                                    //err
                                                    this.$swal({
                                                        confirmButtonText:this.$t('okButton'),
                                                        type:'error',
                                                        title:err,
                                                        timer:3000
                                                    }).catch(this.$swal.noop);
                                                    setTimeout(function() {
                                                        _this.table = {guests: []};
                                                        setTimeout(function () {
                                                            $('[data-dbid="' + tableID + '"]').click()
                                                        }, 50)
                                                    },50);
                                                })
                        this.saving = false;
                        return true;
                    }
                })
            },
            async setTableGuests(){
                if(typeof this.table.dbID ==='undefined') this.openedTableGuests = [];

                if(typeof this.event.guests.filter !=='function'){
                    this.openedTableGuests = [];
                }else {
                    this.openedTableGuests = this.event.guests.filter((_) => {
                        if (_.tableID == this.table.dbID) return true;
                        return false;
                    });
                }

            },
            setTable(table, ignoreTableGuestListOpened = false){
                this.tableChangeThrottled2 = setTimeout(()=>{
                    if(!this.tableGuestListOpen || ignoreTableGuestListOpened) {
                        this.tableName = table.name;
                        if (table === 'initial') {
                            this.table = {name: '', guests: [], id: 0};
                        } else {
                            this.table = table;
                        }
                    }
                    clearTimeout(this.tableChangeThrottled2);
                },40);
            },

            tableSwap(){
                let tables = {};
                this.event.presetData.sort((a,b)=>a.tableNum-b.tableNum).filter(table=>table.tableNum !== "").forEach(_=>{
                    tables[_.dbID] = _.tableNum;
                });
                //table 1 select
                this.$swal({
                    title:this.$t('selectFirstTable'),
                    input:'select',
                    inputOptions: tables,
                    inputPlaceholder: this.$t('choose'),
                    showCancelButton: true
                }).then((firstTableID) => {

                    if(firstTableID !== ''){

                        tables = {};
                        this.event.presetData.forEach(_=>{
                            if(_.dbID !== firstTableID) tables[_.dbID] = _.tableNum;
                        });

                        this.$swal({
                            title:this.$t('selectSecondTable'),
                            input:'select',
                            inputOptions: tables,
                            inputPlaceholder: this.$t('choose'),
                            showCancelButton: true
                        }).then((secondTableID) => {

                            if(secondTableID !== ''){

                                this.$swal({
                                    title: this.$t('tablesSwapPrompt'),
                                    text: this.$t('unrevetableOperation'),
                                    type: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#d33',
                                    cancelButtonColor: '#3085d6',
                                    confirmButtonText: this.$t('yes'),
                                    cancelButtonText: this.$t('no')
                                }).then((result) => {

                                    if (result === true) {

                                        this.event.presetData.filter(tbl=>{
                                           if(tbl.dbID === firstTableID) tbl.dbID = 'first';
                                           if(tbl.dbID === secondTableID) tbl.dbID = 'second';
                                        });

                                        this.event.presetData.filter(tbl=>{
                                            if(tbl.dbID === 'first') tbl.dbID = secondTableID;
                                            if(tbl.dbID === 'second') tbl.dbID = firstTableID;
                                        });

                                        this.save();
                                    }
                                })
                                    .catch(()=>{
                                        /*do nothing*/
                                    });


                            }
                        })
                    }
                })
            },

            save(){
                this.$store.dispatch('updateEvent',{'id':this.event.id,'presetData':this.event.presetData})
                    .then((_)=>{
                        this.setLayout({elements:this.event.presetData})
                    })
                    .catch(err => {
                        this.$swal({
                            confirmButtonText:this.$t('okButton'),
                            type:'error',
                            title:this.$t('fatalError'),
                            timer:3000
                        }).catch(this.$swal.noop);
                    })
            },

            onMouseUpdate(e){
                this.currentPointerPosition.x = e.pageX;
                this.currentPointerPosition.y = e.pageY;
                console.log(x, y);
            }

        },
        beforeMount(){
            this.showLoader = true;
            let eventID = this.$router.currentRoute.params.eventID;
            if(typeof eventID ==='undefined' || !eventID) this.$router.push('/');
            this.$store.dispatch('getEvent',eventID)
                .then(response =>{
                    //success
                    response.data.presetLocked = response.data.presetLocked === 1;
                    this.event = response.data;
                    this.fetchGuests();
                })
                .catch(err => {
                    //err
                    console.warn(err)
                    this.$router.push('/');
                    return;
                });

        },
        mounted(){
            let _this = this;

            try {
                $("#dragablleItems").getNiceScroll().remove();
            }catch(e){

            }
            if(typeof $("#dragablleItems").niceScroll !=='function') {
                $.getScript("/static/js/niceScroll.min.js", function () {
                    setTimeout(function(){
                        $("#dragablleItems").niceScroll()
                    },500);
                });
            }else{
                setTimeout(function(){
                    $('#dragablleItems').niceScroll()
                },500);
            }


            $(document).ready(function(){
                window.saveGuest = function () {
                    let guest= {
                        fullName:$('#guestNameEdit').val(),
                        coming:(isNaN(parseInt($('#guestComingQuantity').text())) ? 0 : parseInt($('#guestComingQuantity').text())),
                        _group:$('#modalGuestGroup').val(),
                        id:parseInt($('#guestID').val()),
                        event:parseInt($('#eventID').val()),
                    };

                    if($('#reserve').val() === "yes") {
                        guest.isReserve = true;
                    }

                    _this.$store.dispatch('updateGuest',guest)
                                            .then(response =>{
                                                //success
                                                $("#modal-editGuest").iziModal({
                                                    autoOpen: 1,
                                                });
                                                _this.fetchGuests()
                                            })
                                            .catch(err => {
                                                //err
                                                _this.$swal({
                                                    confirmButtonText:_this.$t('okButton'),
                                                    type:'error',
                                                    title:_this.$t('saveFailed'),
                                                    timer:3000
                                                }).catch(_this.$swal.noop);
                                            })
                    return false;
                }

            });
        }
    }
</script>
<style>

    .seatingView h2{
        color:#7893c1;
        font-size: 1.706rem;
        font-weight: 700;
    }
    .seatingView h3{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .seatingView.innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .seatingView .editEventActions{
        float:left;
        margin-top: 6px;
    }



    .seatingView .howToStart{
        width: 181px;
        height: 42px;
        border: 1px solid #52dbcd;
        border-radius: 21px;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* ie10+ */
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        /* w3c */
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        /* ie6-9 */
    }
    .seatingView .howToStart svg{
        display: inline-block;
        vertical-align: middle;
        width: 22px;
        height: 22px;
        fill: #fff;
        margin-left: 5px;
    }
    .seatingView .howToStart span{
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
        font-size: 0.8235rem;
        font-weight: 700;
        color:#fff;
    }

    .seatingView .eventInfoWrapper{
        padding: 20px 30px;
    }
    .seatingView .eventInfoWrapper h2 svg{
        display: inline-block;
        vertical-align: middle;
        width:52px;
        height:52px;
        fill:#293b5a;
        margin-left: 10px;
    }
    .seatingView .eventInfoWrapper h2 span{
        display: inline-block;
        vertical-align: middle;
    }
    .seatingView .eventInfoWrapper h2 span .date{
        color:#293b5a;
        font-size: 1.059rem;
        font-weight: 400;
    }
    .seatingView .mainInfo{
        margin: 20px 0;
    }
    .seatingView .mainInfo li{
        display:inline-block;
        vertical-align: middle;
        font-size: 1.059rem;
    }
    .seatingView .mainInfo li + li{
        margin-right:15px;
    }
    .seatingView .mainInfo li svg{
        display:inline-block;
        vertical-align: middle;
        margin-left: 7px;
        fill:#293b5a;
    }
    .seatingView .mainInfo li svg.i_location{
        width:28px;
        height:28px;
    }
    .seatingView .mainInfo li svg.i_users{
        width:40px;
        height: 30px;
    }
    .seatingView .mainInfo li span{
        display:inline-block;
        vertical-align: middle;
    }
    .seatingView .mainInfo li span.liTitle{
        font-weight: 700;
        color:#7791be;
    }
    .seatingView .moreInfo{
        background: #f0f0f0;
        padding:15px;
    }
    .seatingView .moreInfo li{
        display:inline-block;
        vertical-align: top;
    }
    .seatingView .moreInfo li h3{

        margin-bottom: 10px;
    }
    .seatingView .moreInfo li + li{
        margin-right: 20px;
    }
    .seatingView .bottomPart{
        float: right;
        width: 100%;
    }
    .seatingView .placeNumbers{
        font-weight: 400;
    }
    .seatingView .guestWrap{
        padding:15px;
    }
    .seatingView .guestWrap h2{
        margin-bottom: 20px;
    }
    .seatingView .guestWrap h2 svg{
        display: inline-block;
        vertical-align: middle;
        fill: #ff0000;
        width:22px;
        height:22px;
        margin-right: 15px;
    }
    .seatingView .guestWrap .selectWrap{
        width: 250px;
    }
    .seatingView .guestWrap .selectWrap select{
        background: #fff;
        color:#293b5a;
        font-size: 0.8824rem;
    }
    .seatingView .guestWrap label{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }

    .seatingView .totalSeats{
        width:100%;
        height:100%;
        background: -moz-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41, 59, 90, 1)), color-stop(100%, rgba(123, 150, 196, 1)));
        background: -webkit-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: -o-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: -ms-linear-gradient(0deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        background: linear-gradient(90deg, rgba(41, 59, 90, 1) 0%, rgba(123, 150, 196, 1) 100%);
        filter: progid: DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4', GradientType=1 );
        text-align: center;
        color:#cdcdcd;
        font-size: 1.118rem;
        padding: 15px 0;
    }
    .seatingView .innerTotalSeats{
        display: inline-block;
        text-align: right;
    }
    .seatingView .totalSeats .ulamCapacity{
        font-size: 2rem;
        color:#fff;
        font-weight: bold;
        font-style: italic;
        margin-left: 5px;
    }
    .seatingView .totalSeats .ulamCapacity + span{
        font-style: italic;
        font-size: 0.9412rem;
    }
    .seatingView .ulamLayoutWrapper{
        width:100%;
        height:100%;
        overflow: auto;
        /*display: flex;*/
    }
    #ulamLayout{
        width: 720px;
        height:720px;
        background: url("/static/images/layoutBg.jpg") no-repeat right top;
        background-size: contain;
        /*flex-grow: 1;*/
    }
    .seatingView .grid{
        width:100%;
        height: 100%;
    }

    .seatingView .item{
        display: inline-block;
        padding: 20px;
        position: relative;
        width:32%;
        text-align: center;
    }
    #list-1 .item{
        padding:10px;
    }
    .seatingView .item .imgWrap{
        margin-bottom: 20px;
    }
    .seatingView .item .imgWrap img{
        max-width: 100%;
    }
    #gridWrap{
        position: relative;
    }
    #gridWrap .item{
        width:auto;
        position: absolute;
        padding: 0;
    }
    #gridWrap .item .rectangle,
    #gridWrap .item .square:not(.wood),
    #gridWrap .item .circle{
        background: #fff;
    }
    .seatingView .tableWrap{
        position: relative;
        padding: 3px 3px;
        display: inline-block;
    }
    #gridWrap .item .tableNum {
        color: #314364;
        font-size: 1.3rem;
        font-weight: bold;
    }
    #gridWrap [data-table-usage]:after{
        content: attr(data-table-usage);
        position: absolute;
        bottom: 4px;
        right: 7px;
        font-weight: bold;
        opacity: 0.7;
        font-size: 11px;
    }
    #gridWrap [data-table-usage][data-shape="circle"]:after{
        bottom: -22px;
        color: white;
        opacity: 1;
        text-shadow: 1px 0 black, 0 1px black, -1px 0 black, 0 -1px black;
    }
    .seatingView .rectangle,
    .seatingView .square{
        margin:0 auto;
        border: 2px solid #c1bfbf;
        min-width: 30px;
        min-height: 30px;

    }
    .seatingView .ellipseTable .rectangle{
        min-width: 25px;
        border-radius: 50%;
    }
    .seatingView .seat{
        width:10px;
        height:8px;
        border: 1px solid #000;
        border-radius: 2px;
        display: block;
        background: #fff;
    }
    .seatingView .circlePrecWrap{
        width:76px;
        height:76px;
        display: inline-block;
    }
    .seatingView .precentageTxt{
        display: inline-block;
        padding-right: 15px;
        text-align: right;
    }
    .seatingView .circlePrecWrap .circle-bg {
        fill: none;
        stroke: #eee;
        stroke-width: 1.8;
    }

    .seatingView .circlePrecWrap .circle {
        fill: none;

        stroke-width: 1.8;
        stroke-linecap: round;
        animation: progress 1s ease-out forwards;
    }
    .seatingView .seatedPlaces .circle{
        stroke: #47ce41;
    }
    .seatingView .unSeatedPlaces .circle{
        stroke: #293b5a;
    }
    @keyframes progress {
        0% {
            stroke-dasharray: 0 100;
        }
    }
    .seatingView .circlePrecWrap .percentage {
        fill: #626262;
        font-style: italic;
        font-size: 0.5rem;
        text-anchor: middle;
    }
    .seatingView .precentageWrap{
        padding:15px;
        text-align: center;
    }
    .seatingView .precentageIcon{
        position: relative;
        margin-right: 5px;
    }
    .seatingView .precentageIcon .mainIcon{
        width: 18px;
        height: 16px;
        border-radius: 5px;
        border: 1px solid #fff;
        display: inline-block;
        z-index: 1;
        position: relative;
    }
    .seatingView .precentageIcon span:not(.mainIcon){
        width: 24px;
        height: 14px;
        position: absolute;
        top: -1px;
        right: -3px;
        border-radius: 5px 5px 0px 0px;
    }
    .seatingView .seatedPlaces .precentageIcon span:not(.mainIcon),
    .seatingView .seatedPlaces .precentageIcon .mainIcon{
        background:#47ce41;
    }
    .seatingView .unSeatedPlaces .precentageIcon span:not(.mainIcon),
    .seatingView .unSeatedPlaces .precentageIcon .mainIcon{
        background:#293b5a;
    }
    .seatingView .placesNum{
        color: #4c4c4c;
        font-weight: bold;
        font-size: 1.412rem;
        line-height: 20px;
    }
    .seatingView .seatedStatus{
        color:#9b9b9b;
        font-size: 1.059rem;
    }
    .seatingView .rectangleTable .seat,
    .seatingView .squareTable .seat{
        display: inline-block;
        position: relative;
    }
    .seatingView .rectangleTable .seat:before,
    .seatingView .squareTable .seat:before{
        content: "";
        width: 6px;
        height: 6px;
        position: absolute;
        background: #fff;
        border: 1px solid #000;
        border-radius: 2px;
    }
    .seatingView .rectangleTable .side1 .seat,
    .seatingView .squareTable .side1 .seat{
        vertical-align: top;
    }
    .seatingView .rectangleTable .side3 .seat,
    .seatingView .squareTable .side3 .seat{
        vertical-align: top;
    }
    .seatingView .rectangleTable .side2 .seat,
    .seatingView .rectangleTable .side0 .seat,
    .seatingView .squareTable .side2 .seat,
    .seatingView .squareTable .side0 .seat{
        width: 8px;
        height: 10px;
        display: block;

    }
    .seatingView .rectangleTable .side0 .seat:before,
    .seatingView .squareTable .side0 .seat:before{
        left: -2px;
        top: 1px;
    }
    .seatingView .rectangleTable .side1 .seat:before,
    .seatingView .squareTable .side1 .seat:before{
        left: 1px;
        top: -2px;
    }
    .seatingView .rectangleTable .side2 .seat:before,
    .seatingView .squareTable .side2 .seat:before{
        top: 1px;
    }
    .seatingView .rectangleTable .side3 .seat:before,
    .seatingView .squareTable .side3 .seat:before{
        bottom: -2px;
        right: 1px;
    }

    .seatingView .rectangleTable .side0 .seat + .seat,
    .seatingView .squareTable .side0 .seat + .seat{
        margin-top:3px;
    }
    .seatingView .rectangleTable .side1 .seat + .seat,
    .seatingView .squareTable .side1 .seat + .seat{
        margin-right:3px;
    }
    .seatingView .rectangleTable .side2 .seat + .seat,
    .seatingView .squareTable .side2 .seat + .seat{
        margin-top:3px;
    }
    .seatingView .rectangleTable .side3 .seat + .seat,
    .seatingView .squareTable .side3 .seat + .seat{
        margin-right:3px;
    }

    .seatingView .rectangleTable .tableSide,
    .seatingView .squareTable .tableSide{
        position: absolute;
        text-align: center;
    }
    .seatingView .rectangleTable .side0,
    .seatingView .squareTable .side0{
        left:100%;
        top: 50%;
        transform: translate(0,-50%);
    }
    .seatingView .rectangleTable .side1,
    .seatingView .squareTable .side1{
        top:100%;
        right: 50%;
        transform: translate(50%,0);
        width:calc(100% - 6px);
        height: 8px;
    }
    .seatingView .rectangleTable .side2,
    .seatingView .squareTable .side2{
        right:100%;
        top: 50%;
        transform: translate(0,-50%) rotate(180deg);
    }
    .seatingView .rectangleTable .side3,
    .seatingView .squareTable .side3{
        bottom: 100%;
        right: 50%;
        transform: translate(50%,0);
        width:calc(100% - 6px);
        height: 8px;
    }
    .seatingView .itemLabel{
        margin-top: 15px;
    }
    .seatingView .circleTable .circle{
        margin: 0 auto;
        border: 2px solid #c1bfbf;
        min-width: 30px;
        min-height: 30px;
        border-radius: 50%;
    }
    .seatingView .circleTable .circle .seat{
        position: absolute;
        top: 40%;
        left: 40%;

    }
    #gridWrap .seat,
    #gridWrap .seat:before{
        background:#fff!important;
    }
    #gridWrap .seat.notComing:before,
    #gridWrap .seat.notComing{
        background: #ff1010!important;
    }
    #gridWrap .seat.reserve:before,
    #gridWrap .seat.reserve{
        background: #0034ff !important;
    }
    #gridWrap .seat.confirmed:before,
    #gridWrap .seat.confirmed{
        background: #47ce41!important;
    }
    #gridWrap .seat.maybe:before,
    #gridWrap .seat.maybe{
        background: #FAFF04!important;
    }
    #gridWrap .seat.notResponded:before,
    #gridWrap .seat.notResponded{
        background: #A2A2A2!important;
    }
    .seatingView .circleTable .seat:before{
        content: "";
        width: 6px;
        height: 6px;
        position: absolute;
        background: #fff;
        border: 1px solid #000;
        border-radius: 2px;
        position: absolute;
        bottom:-2px;
        right:1px;
    }
    .seatingView .ellipseTable .side0 .seat:first-child{    transform: rotate(-21deg) translate(-2px);}
    .seatingView .ellipseTable .side0 .seat:last-child{    transform: rotate(21deg) translate(-2px);}
    .seatingView .ellipseTable .side2 .seat:first-child{transform: rotate(-21deg) translate(-2px);}
    .seatingView .ellipseTable .side2 .seat:last-child{    transform: rotate(21deg) translate(-2px);}
    .seatingView .squareTable.wood .square{
        background:#e1e1e1;
    }
    #gridWrap .itemLabel{
        display: none;
    }
    .seatingView .guestFilter{
        margin-bottom:23px;
        padding:15px;

    }
    .seatingView .guestFilter input,
    .seatingView .guestFilter select{
        background: #fff;
        color: #555555;
        height:43px;
        line-height: 43px;
        font-size: 0.8235rem;
    }
    .seatingView .guestFilter .inputWrap.searchWrapper input {
        padding-left: 40px;
    }
    .seatingView .guestFilter .inputWrap.searchWrapper .searchEvent {
        position: absolute;
        top: calc(50% - 10px);
        left: 20px;
    }
    .seatingView .guestFilter .inputWrap.searchWrapper .searchEvent svg {
        fill: #293b5a;
        width: 18px;
        height: 20px;
        display: block;
    }
    .seatingView .guestFilter .inputWrap.searchWrapper input[type="search"]::-webkit-input-placeholder{color:#adadad;font-style: italic;font-size: 0.8824rem;}
    .seatingView .guestFilter .inputWrap.searchWrapper  input[type="search"]:-moz-placeholder{color:#adadad;font-style: italic;font-size: 0.8824rem;}
    .seatingView .statusBar{
        width: 100%;
        height:43px;
        line-height:40px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
    }
    .seatingView .statusBtn{
        float: right;
        width:16.6%;
        text-align: center;
        padding: 0 5px;
    }
    #all span{
        color:#293b5a;
        font-weight: 700;
    }
    #all{
        border-radius: 27px 0 0 27px;
    }
    .seatingView .statusBtn svg{
        width:24px;
        height:24px;
        display: inline-block;
        vertical-align: middle;
        margin-left:5px;
    }
    .seatingView .statusBtn span{
        color:#555555;
        font-size: 0.7rem;
        display: inline-block;
        vertical-align: middle;
    }
    svg.i_arraiving{
        fill:#41b53e;
    }
    svg.i_notArraiving{
        fill:#bb1b1b;
    }
    svg.i_maybeArraiving{
        fill:#e49e9e;
    }
    svg.i_didentAnswer{
        fill:#656565;
    }
    .seatingView .guestFilter .col-lg-6{margin-top:15px;}
    .seatingView .guestFilter .inputWrap>label{
        color:#293b5a;
        font-size: 0.8235rem;
        margin-bottom: 7px;
        font-weight: 700;
    }
    .seatingView .guestItem .guestIcon,
    .seatingView .guestItem .guestInfo{
        display: inline-block;
        vertical-align: top;
    }
    .seatingView .guestItem .guestIcon svg{
        width:19px;
        height:19px;
        vertical-align: middle;
        margin-left: 5px;
    }
    .seatingView .guestName{
        color:#293b5a;
        font-weight: 700;
        font-size: 1.059rem;
    }
    .seatingView .guestGroup{
        color:#7994c2;
        font-size: 0.7647rem;
    }
    .seatingView .guestTable{
        margin-top: 5px;
    }
    .seatingView .guestTable .i_table{
        width:16px;
        height:15px;
        fill:#293b5a;
        vertical-align: middle;
        display: inline-block;
    }
    .seatingView .guestTable .tableNum:after{
        content: "|";
        margin-right: 5px;
    }
    .seatingView .guestTable .tableNum,
    .seatingView .guestTable .tableName{
        vertical-align: middle;
        display: inline-block;
        color:#6f6f6f;
        font-size: 0.7647rem;
    }
    .seatingView .guestAmount{
        vertical-align: middle;
        display: inline-block;
        margin-right:20px;
    }
    .seatingView .guestAmount .i_user{
        width:13px;
        height:15px;
        fill:#293b5a;
        vertical-align: middle;
        display: inline-block;
    }
    .seatingView .guestAmount span{
        vertical-align: middle;
        display: inline-block;
        color:#6f6f6f;
        font-size: 0.7647rem;
    }
    .seatingView .guestEdit{
        float: left;
    }
    .seatingView .guestEdit svg.editGuestBtn{
        width:16px;
        height:16px;
        fill:#293b5a;
    }
    .seatingView .guestEdit svg.deleteGuestBtn{
        width:11px;
        height:11px;
        fill:#7792bf;
    }
    .seatingView .guestList{
        max-height: 800px;
        height: auto;
        overflow-x: hidden;
        overflow-y: scroll;
    }
    .seatingView .guestList.musk .guestItem:before{
        content: "";
        width: 100%;
        height:100%;
        position: absolute;
        top:0;
        right:0;
        background: #50668c;
    }
    .seatingView .guestItem{
        border-bottom: 1px solid #293b5a;
        padding:10px;
        background: #f2f2f2;
        z-index: 0;
    }
    .seatingView .guestList li:nth-child(odd){
        background: #e7e7e7;
    }
    #dragablleItems .guestItem{
        cursor: move;
    }
    .seatingView .gu-mirror,
    #dragablleItems .guestItem:hover{
        box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.23);
        z-index: 1;
        position: relative;
    }
    .seatingView .gu-mirror{
        opacity: 1;
        list-style: none;
    }
    .seatingView .gu-mirror .guestEdit svg.deleteGuestBtn,
    .seatingView .guestList .guestEdit svg.deleteGuestBtn{
        display: none;
    }
    #addTable .guestEdit svg.editGuestBtn{
        display: none;
    }
    .seatingView .scrollerWrap{
        overflow-y: scroll !important;
        height: 500px !important;
    }
    .seatingView .mCS-dir-rtl>.mCSB_inside>.mCSB_scrollTools, .mCS-dir-rtl>.mCSB_outside+.mCSB_scrollTools{
        right:0;
        left:auto;
    }
    .seatingView .mCS-dir-rtl:not(.mCS_no_scrollbar)>.mCSB_inside>.mCSB_container{
        margin-right: 20px;
        margin-left: 0px;
    }
    .seatingView .mCSB_scrollTools .mCSB_draggerRail{
        width: 6px;
        background-color: #f0f0f0;
    }
    .seatingView .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{
        width: 6px;
        background-color: #7a94c2;
    }
    .seatingView .mCSB_scrollTools .mCSB_dragger.mCSB_dragger_onDrag .mCSB_dragger_bar, .mCSB_scrollTools .mCSB_dragger:active .mCSB_dragger_bar,
    .seatingView .mCSB_scrollTools .mCSB_dragger:hover .mCSB_dragger_bar{
        background-color: #7a94c2;
    }
    .seatingView .scrollerWrap {
        height: calc(100% - 59px);
    }
    .seatingView .sideHeight{
        min-height:795px;
    }
    .seatingView .tableGuestList{
        width:325px;
        height:285px;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.53);
        background: #ffffff;
        position: absolute;
        transform: translateX(-50%);
        z-index: 999;
        display: none;
        top: 0px;
        left: 0px;
    }
    .seatingView .tableGuestList:before{
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #fff;
        position: absolute;
        top: 400px;
        right: calc(50% - 4px);
        z-index: 1;
    }
    .seatingView .tableGuestList:after{
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-top: 12px solid #dddddd;
        position: absolute;
        top: 400px;
        right: calc(50% - 6px);
    }
    .seatingView .tableGuestListH{
        padding: 10px 10px 5px;
        float: right;
        width:100%;
        border-bottom:1px solid #293b5a;
        text-align: right;
    }
    .seatingView .tableGuestList .closeBtn{
        float: left;
    }
    .seatingView .tableGuestList .closeBtn svg{
        width:11px;
        height:11px;
        fill:#293b5a;
        display: block;
    }
    .seatingView .tableGuestList h3{
        float: right;
        font-size: 0.8824rem;
        font-weight: 700;
    }
    .seatingView .tableGuestListH>div{
        float: right;
        width:100%;
        line-height: 16px;
    }
    .seatingView .tableGuestListH label{
        margin-left: 7px;
        color: #7a94c2;
        font-size: 0.7059rem;
    }
    .seatingView .tableGuestList.open{
        display: block;
        top: 33% !important;
        left: 50% !important;
        width: 40% !important;
        height: 46%;
        position: fixed;
    }
    .seatingView .editWrap{
        position: absolute;
        top: 32px;
        right: 10px;
    }
    .seatingView .saveNewName{
        position: absolute;
        left:10px;
        top:calc(50% - 4px);
        z-index: -1;
        opacity: 0;
    }
    .seatingView .saveNewName svg{
        width:11px;
        height:8px;
        fill:#293b5a;
        display: block;
    }
    #editbleTableName{
        color: #7a94c2;
        font-size: 0.7059rem;
        z-index: -1;
        opacity: 0;
        border: 1px solid #bfc1c5;
        border-radius: 10px;
        display: block;
        background: #fff;
        min-width: 130px;
        padding-right: 5px;
        transition: all .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;
    }
    #editbleTableName:focus{
        z-index: 1;
        opacity: 1;
        transition: opacity .25s ease-in-out;
        -moz-transition: opacity .25s ease-in-out;
        -webkit-transition: opacity .25s ease-in-out;

    }
    #editbleTableName:focus + .saveNewName{
        z-index: 1;
        opacity: 1;
    }
    .seatingView .editName{
        display: inline-block;
        vertical-align: middle;
    }
    .seatingView .editName svg{
        width:11px;
        height:11px;
        display: block;
    }
    .seatingView .tableCapacity, .tableAvailability{
        color:#484848;
        font-size: 0.7059rem;
        line-height: 0.7059rem;
    }
    .seatingView .tableCapacity{
        margin-left:10px;
    }
    .seatingView .tableGuestList .scrollerWrap{
        float: right;
        width: 100%;
        /*height:400px;*/
    }

    .seatingView .tableGuestList .scrollerWrap ul{
        width:100%;
        min-height: 100%;
    }
    #addTable{
        min-height: 165px;
    }
    #addTable .guestName{
        font-size: 0.8235rem;
    }
    #addTable .guestGroup{
        font-size: 0.6471rem;
    }
    #addTable .guestTable{
        margin:0;

        line-height: 13px;
    }
    #addTable .guestItem{
        padding:5px;
    }
    #addTable .guestTable .tableNum,
    #addTable .guestTable .tableName,
    #addTable .guestTable .i_table{
        display: none;
    }
    #addTable .guestTable .guestAmount{
        margin:0;
    }
    #addTable .guestAmount .i_user{
        width: 8px;
        height: 10px;
    }
    #addTable .guestEdit{
        margin-left: 5px;
        margin-top: 12px;
    }
    .seatingView .tableGuestList .mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar{
        width: 4px;
    }
    .seatingView .tableGuestList .mCSB_scrollTools .mCSB_draggerRail{
        width: 4px;
    }
    .seatingView .tableGuestList .mCS-dir-rtl:not(.mCS_no_scrollbar)>.mCSB_inside>.mCSB_container{
        margin-right: 16px;
    }
    #modal-editGuest{
        background: #efefef;
    }
    #modal-editGuest .inputWrap input, #modal-editGuest .inputWrap select, #modal-editGuest{
        background: #fff;
        color:#555555;
        font-size: 0.8235rem;
    }
    #modal-editGuest h2{
        color:#293b5a;
        font-size: 2rem;
        font-weight: 700;
    }
    #modal-editGuest h3{
        margin:10px 0;
        margin-bottom: 20px;
    }
    #modal-editGuest label{
        color:#434343;
        font-size: 1rem;
        margin-bottom: 10px;
        display: block;
    }
    #modal-editGuest h3 svg{
        width: 22px;
        height:26px;
        vertical-align: middle;
        display: inline-block;
        margin-left: 7px;
        fill: #7690bd;
    }
    #modal-editGuest h3 span{
        color:#7690bd;
        font-size: 1.176rem;
        vertical-align: middle;
        display: inline-block;
    }
    .seatingView .statusDropDown li{
        padding:7px 0;
        cursor: pointer;
    }
    .seatingView .selectedValue span svg,
    .seatingView .statusDropDown li svg{
        width:24px;
        height:24px;
        vertical-align: middle;
        display: inline-block;
        margin-left:7px;
    }
    .seatingView .selectedValue span span,
    .seatingView .statusDropDown li span{
        vertical-align: middle;
        display: inline-block;
        color:#555555;
        font-size: 0.8235rem;
    }
    .seatingView .selectedValue{
        width: 100%;
        height: 54px;
        line-height: 54px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        background: #fff;
        padding: 0 15px;
        color: #fff;
    }
    .seatingView .statusDropDown{
        z-index: 1;
        background: #fff;
        width: 125px;
        padding: 0 10px;
        border: 1px solid #dddddd;
        position: absolute;
        top: calc(100% + 15px);
        right: 50%;
        transform: translateX(50%);
        display: none;
    }
    .seatingView .statusDropDown.open{
        display: block;
    }
    .seatingView .statusDropDown:before {
        content: "";
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 12px solid #dddddd;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 6px);
    }
    .seatingView .statusDropDown:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #fff;
        position: absolute;
        bottom: 100%;
        right: calc(50% - 4px);
    }
    .seatingView .secondLevel{
        margin:0 -7px;
    }
    .seatingView .secondLevel div[class^="col-"]{
        padding:0 7px;
    }
    .seatingView .selectedValue{
        position: relative;
    }
    .seatingView .selectedValue .i_select{
        width:16px;
        height:9px;
        position:absolute;
        top:calc(50% - 4px);
        left:10px;
        fill:#8798b5;
    }
    #modal-editGuest{
        max-width: 700px!important;
    }
    .seatingView .guestCounter{
        width: 100%;
        height: 54px;
        line-height: 52px;
        border-radius: 27px;
        border: 1px solid #bfc1c5;
        float: right;
    }
    .seatingView .guestCounter span{
        width:33.3%;
        float: right;
        text-align: center;
        height: 100%;
    }
    .seatingView .guestCounter span.plus{
        background: #f2f2f2;
        border-radius: 0 27px 27px 0;
    }
    .seatingView .guestCounter span.minus{
        background: #f2f2f2;
        border-radius: 27px 0 0 27px;
    }
    .seatingView .guestCounter span svg{
        width: 17px;
        height: 100%;
        fill: #293b5a;
        display: block;
        margin:0 auto;
    }
    .seatingView .guestCounter span.value{
        font-size: 1rem;
        color: #434343;
    }
    #modal-editGuest .row + .row{
        margin-top:20px;
    }
    .seatingView .inputWrap.submitWrap.deleteBtn button{
        background: #fff;
    }
    .seatingView .inputWrap.submitWrap.deleteBtn button svg{
        width:18px;
        height:19px;
        fill:#7893c1;
        display: inline-block;
        vertical-align: middle;
        margin-left: 7px;
    }
    .seatingView .inputWrap.submitWrap.deleteBtn button span{
        color:#7893c1;
        display: inline-block;
        vertical-align: middle;
    }
    .seatingView .statusBar .active{
        background: #f3f3f3 !important;
        height:41px
    }
    #arrive.active{
        border-radius: 0 27px 27px 0;
    }
    @media only screen and (max-width:1450px){
        .seatingView .statusBtn:not(#all) span{display: none;}
        .seatingView .statusBtn svg{margin:0;}
        .seatingView .guestFilter .col-lg-6{width: 100%;}
        .seatingView .guestWrap{height: calc(100% - 327px);}
    }
    .ulamLayoutWrapper{
        background: none;
        box-shadow: none;
        border: none;
    }
    .not_active{
        opacity: .5;
    }
    .item .active{
        font-weight: bold;
        border-color: red !important;
        border-width: 4px;
    }
    .overCapacity div:first-child {
        background-color: #fdfaa1 !important;
    }
    .guestItem.gu-mirror{
        transform: scale(0.2);
    }
    @media only screen and (max-width:769px) and (max-height: 1025px) {
        .innerBox,.innerBox.filterBox{
            padding: 20px 0px 20px 0px;
        }
        .statusBar .active{
            height:100%
        }
        .innerBox.filterBox .inputWrap.statusBarWrap{
            width: 600px;
            padding-bottom: 20px;
        }
    }
</style>
